import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Form, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap'
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/auth/user"

class AccountAdd extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.state = this.getInitialState()
    }

    getInitialState = () => {
        return {
            errors: {},
            rePassword: "",
            data: {
                id: "",
                userName: "",
                password: "",
                roleId: ""
            }
        }
    }

    // Function that will be executed when the submit button (Toevoegen) is pressed
    handleSubmit(event) {
        event.preventDefault()
        Api.print("Data to send")
        Api.print(this.state.data)
        Api.print("---------------")

        if (this.state.data.password !== this.state.rePassword)
            this.setState({ errors: { password: 'Passwords do not match' } })

        else {
            Api.PostApi(FETCH_URL, this.state.data, this.props.history)
                .then(response => {
                    Api.print("Response")
                    Api.print(response)
                    Api.print(("---------------"))
                    if (response !== undefined && response.password != undefined) {
                        this.setState({ errors: response });
                    }
                    else {
                        alert("Account created")
                        window.location.href = "/admin/accounts";
                        // TODO: Show message OK
                    }
                })
        }
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value

        if (name === "roleId") this.setState({ data: { ...this.state.data, [name]: parseInt(value) } })
        else name === "rePassword" ? this.setState({ [name]: value }) : this.setState({ data: { ...this.state.data, [name]: value } })

    }

    render() {
        let data = this.state.data
        let rePassword = this.state.rePassword
        let errors = this.state.errors
        return (
            <div>
                <Row>
                    <Form horizontal onSubmit={this.handleSubmit}>
                        <Col md={12}>Password requirements:</Col>
                        <Col md={12}>Must be at least 6 characters.</Col>
                        <Col md={12}>Must have at least one lowercase ('a'-'z') and at least one uppercase ('A'-'Z')</Col>
                        <Col md={12}>Must have at least one digit ('0'-'9').</Col>
                        <Col md={12}>Must have at least one non alphanumeric character.</Col>
                        <Col md={12}>
                            <FormGroup controlId="AccountTitel">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Naam *
                                </Col>
                                <Col sm={6}>
                                    <FormControl type="text" name="userName" value={data.userName} required onChange={this.handleChange} />
                                    {Api.showError(errors, "userName")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="AccountPassword">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Wachtwoord *
                                </Col>
                                <Col sm={6}>
                                    <FormControl type="password" name="password" value={data.password} required onChange={this.handleChange} />
                                    {Api.showError(errors, "password")}
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="AccountPasswordCheck">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Wachtwoord  controle *
                                </Col>
                                <Col sm={6}>
                                    <FormControl type="password" name="rePassword" value={rePassword} required onChange={this.handleChange} />
                                    {Api.showError(errors, "password")}
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="AccountRol">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Rol *
                                </Col>
                                <Col sm={6}>
                                    <FormControl componentClass="select" name="roleId" value={data.roleId} required onChange={this.handleChange}>
                                        <option value="">-- kies rol --</option>
                                        {Api.getAccountRoles().map((roleId, index) =>
                                            <option
                                                value={index + 1}
                                                key={"roleId" + index}>
                                                {roleId}
                                            </option>
                                        )}
                                    </FormControl>
                                    {Api.showError(errors, "roleId")}
                                </Col>
                            </FormGroup>

                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <Col sm={12}>
                                    <LinkContainer to="/admin/accounts"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                                    <Button type="submit" className="pull-right">Toevoegen</Button>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Form>
                </Row>
            </div>
        );
    }
}

export default AccountAdd;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Accounts/Add.js